export default {
  en: {
    isPaused: {
      text: 'Jobs in this pipeline will not be triggered until the pipeline is resumed.',
      title: 'Pipeline paused.',
    },
    pause: 'Pause',
    paused: 'paused',
    resume: 'Resume',
    resumePipeline: 'Resume pipeline',
    search: 'Search pipelines',
    start: 'Start',
    startComponent: 'Start component',
    stop: 'Stop',
    stopComponent: 'Stop component',
    schedule: {
      title: 'Scheduled component',
      edit: 'Edit schedule',
      start: 'Next start in {0}',
      stop: 'Next stop in {0}',
    },
    viewStartStop: 'View start-stop pipeline',
    status: {
      failed: 'Failed',
      paused: 'Paused',
      errored: 'Errored',
      aborted: 'Aborted',
      pending: '@:Pending',
      running: 'Running',
      succeeded: 'Succeeded',
    },
  },
  es: {
    isPaused: {
      text: 'Los trabajos en esta pipeline no se activarán hasta que se reanude la pipeline.',
      title: 'Pipeline pausada.',
    },
    pause: 'Pausar',
    paused: 'pausada',
    resume: 'Reanudar',
    resumePipeline: 'Reanudar pipeline',
    search: 'Buscar pipelines',
    start: 'Iniciar',
    startComponent: 'Iniciar componente',
    stop: 'Parar',
    stopComponent: 'Parar componente',
    schedule: {
      title: 'Componente programado',
      edit: 'Editar programación',
      start: 'Próximo inicio en {0}',
      stop: 'Próxima detención en {0}',
    },
    viewStartStop: 'Ver start-stop pipeline',
    status: {
      failed: 'Fallido',
      paused: 'Pausado',
      errored: 'Con errores',
      aborted: 'Abortado',
      pending: '@:Pending',
      running: 'En ejecución',
      succeeded: 'Exitoso',
    },
  },
  fr: {
    isPaused: {
      text: `Les jobs de cette pipeline ne seront pas lancés tant qu'elle n'aura pas été réactivée`,
      title: 'Pipeline mise en pause.',
    },
    pause: 'Pause',
    paused: 'en pause',
    resume: 'Reprendre',
    resumePipeline: 'Reprendre la pipeline',
    search: 'Rechercher des pipelines',
    start: 'Démarrer',
    startComponent: 'Démarrer le composant',
    stop: 'Arrêter',
    stopComponent: 'Arrêter le composant',
    schedule: {
      title: 'Composant programmé',
      edit: 'Modifier le planning',
      start: 'Prochain démarrage dans {0}',
      stop: 'Prochain arrêt dans {0}',
    },
    viewStartStop: 'Afficher la pipeline start-stop',
    status: {
      failed: 'Échoué',
      paused: 'En pause',
      errored: 'Avec erreurs',
      aborted: 'Abandonné',
      pending: '@:Pending',
      running: 'En cours',
      succeeded: 'Réussi',
    },
  },
}
